import React, { ReactElement, useState } from 'react';
import { Card, Typography } from 'antd';
import '../newAdmission/NewAdmissionFooter.less';
import { NEWADMISSIONFOOTER_IMAGES, PARTNERSHIP_LETTER } from '../../../../shared/constants/commonConstants';
import { GLOBAL_URL } from '../../../../shared/constants/dataServiceUrl';
import Lottie from 'react-lottie';
import loader from '../../../../assets/images/lottie-json/loader.json';

const { Title } = Typography;

const NewAdmissionFooter = (): ReactElement => {
  const [showLoader, setShowLoader] = useState(false);
  const [showText, setShowText] = useState(false);

  const downloadLetter = (): any => {
    setShowLoader(true);
    setTimeout((): any => {
      fetch(`${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}Partnership_letter.pdf`)
        .then((response: any): any => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.arrayBuffer();
        })
        .then((pdfBytes: any): any => {
          const pdfBlob = new Blob([pdfBytes], { type: 'application/pdf' });
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const downloadLink = document.createElement('a');
          downloadLink.href = pdfUrl;
          downloadLink.download = PARTNERSHIP_LETTER;
          setTimeout((): any => {
            setShowText(true);
            downloadLink.click();
            URL.revokeObjectURL(pdfUrl);
            setTimeout((): any => {
              setShowText(false);
              setShowLoader(false);
            }, 1000);
          }, 500);
        })
        .catch((error: any): any => {
          console.error('Error fetching PDF:', error);
          setShowText(false);
          setShowLoader(false);
        });
    }, 5000);
  };

  const defaultLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: loader,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };
  return (
    <Card className={`newadmission_footer ${showLoader ? 'mouse-pointer-default' : 'mouse-pointer'}`}
      onClick={showLoader ? undefined : downloadLetter}>
      <div className="circle1" />
      <div className="circle2" />
      <div className="footer-container">
        <Title level={5} className="title">
          IHX - LIVE PARTNERS
        </Title>
        {(!showLoader && !showText) && <div className="text-center download-text">Click to download all partnership letters</div>}
        <div className="parent">
          {NEWADMISSIONFOOTER_IMAGES.map((data: any, index: any): any => (
            <div className="images mb-20" key={index}>
              <svg height="25%" width="100%" style={{ marginLeft: `${data?.leftMargin}`, marginTop: `${data?.top}` }}
              >
                <image
                  href={`${GLOBAL_URL.REACT_APP_COMMON_BUCKET_URL}${data?.img}`} height={`${data?.height}`} />
              </svg>
              <div className={data?.title === 'Reliance General Insurance' ? 'rgi-text' : 'two-lines'}>
                <div dangerouslySetInnerHTML={{ __html: data.title }} />
              </div>
            </div>
          ))}
        </div>
        {(showLoader && !showText) && <div className="lottie-icon-download-loader">
          <Lottie options={defaultLottieOptions} />
        </div>}
        {showText && <div className="success-text text-center">Download Successful</div>}
      </div>
    </Card>
  );
};

export default NewAdmissionFooter;
